import React from 'react'
import PropTypes from 'prop-types'
import Form from '../../../2_Molecules/Form/Form'
import FormGroup from '../../../2_Molecules/FormGroup/FormGroup'
import Input from '../../../1_Atoms/Forms/Input/Input'
import Select from '../../../1_Atoms/Forms/Select/Select'
import { useForm } from '../../../../hooks/useForm'
import { languageController } from '../../../../controllers/language/languageController'
import Button from '../../../1_Atoms/Button/Button'
import formLang from '../../../../controllers/language/shared/form'
import { Svg } from '../../../1_Atoms/Svg/Svg'

function YourInformationStep_TiE({
  language,
  handleNextStep,
}) {
  const purchaseDateOptions = formLang.select.expectedPurchaseOptions;

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    purchaseDate: purchaseDateOptions[0][language]
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    purchaseDate: ['required'],
  }

  const { handleSubmit, handleChange, data, errors } = useForm({
    initState,
    validations,
    onSubmit: () => {
      handleNextStep({ userInformation: data })
    },
  })

  const { firstname, lastname, email, purchaseDate } = data;

  return (
    <div className="mz-your-information-step-tie">
      <div className="mz-container">
        <div className="grid-inner-content">
          <h5 className="mz-your-information-step-tie__title">{languageController.getCopy('tradeInEstimator', 'step3Title')}</h5>
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            requiredFieldsHelperText={true}
          >
            <FormGroup md={2}>
              <Input
                type="text"
                name="firstname"
                label={languageController.getFormCopy('label', 'firstname')}
                value={firstname}
                isRequired={true}
                errorMessage={errors.firstname}
                onChange={handleChange}
                maxLength={50}
              />
              <Input
                type="text"
                name="lastname"
                label={languageController.getFormCopy('label', 'lastname')}
                value={lastname}
                isRequired={true}
                errorMessage={errors.lastname}
                onChange={handleChange}
                maxLength={50}
              />
            </FormGroup>
            <Input
              type="email"
              name="email"
              label={languageController.getFormCopy('label', 'email')}
              value={email}
              isRequired={true}
              errorMessage={errors.email}
              onChange={handleChange}
              maxLength={500}
            />
            <Select
              name="purchaseDate"
              label={languageController.getFormCopy('label', 'expectedPurchaseDate')}
              value={purchaseDate}
              isRequired={true}
              errorMessage={errors.purchaseDate}
              onChange={handleChange}
              options={purchaseDateOptions.map(option => ({
                value: option[language],
                label: option[language],
              }))}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('global', 'continue')}
              buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
              buttonIconPosition="right"
              disabled={(!firstname || !lastname || !email)}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}

YourInformationStep_TiE.propTypes = {
  language: PropTypes.string.isRequired,
  handleNextStep: PropTypes.func.isRequired
}

export default YourInformationStep_TiE

